import Vue from "vue";
import store from "~/store";
import q from "querystring";
import {Exception} from "sass";


const url = Travel.connector;
window.myStore = {objects: {}}

// Response interceptor


export function fetchList(type, params) {

    return new Promise((resolve, reject) => {
        return Vue.axios
                  .post(
                      url,
                      q.stringify({
                          action: type + "/getlist",
                          ...filterParams(params),
                      })
                  )
                  .then((r) => {
                      if (!r.data.success) {
                          reject({
                              message: r.data.message,
                          });
                      }
                      else {
                          resolve(r);
                      }
                  })
                  .catch((e) => {
                      reject(e);
                  });
    });
}

export function getObject(controller, params) {
    if(!controller){
        throw new Error('No controller specified')
        return
    }
    if (!_.isObject(params)) params = {id: params}
    if (controller.indexOf('/') < 0) controller += '/get'
    return new Promise((resolve, reject) => {

        Vue.axios
           .post(
               url,
               q.stringify({
                   action: controller,
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {

                   reject({
                       message: r.data.message,
                   });
               }
               else {

                   resolve(r.data.object);
               }
           })
           .catch((e) => {

               reject(e);
           });
    });
}

export function getModxList(type, params) {
    return new Promise((resolve, reject) => {
        return Vue.axios
                  .post(
                      url,
                      q.stringify({
                          action: type.indexOf('/') < 0 ? type + "/getlist" : type,
                          ...filterParams(params),
                      })
                  )
                  .then((r) => {
                      if (!r.data.success) {
                          reject({
                              message: r.data.message,
                          });
                      }
                      else {
                          resolve(r.data.results);
                      }
                  })
                  .catch((e) => {
                      reject(e);
                  });
    });
}

export function getModxProcessor(processor, params) {
    return new Promise((resolve, reject) => {

        return Vue.axios
                  .post(
                      url,
                      q.stringify({
                          action: processor,
                          ...filterParams(params),
                      })
                  )
                  .then((r) => {
                      if (!r.data.success) {
                          reject({
                              message: r.data.message,
                          });
                      }
                      else {
                          if (r.data.results) resolve(r.data.results);
                          if (r.data.object) resolve(r.data.object);
                          resolve(r.data);
                      }
                  })
                  .catch((e) => {
                      reject(e);
                  });
    });
}

export function fetchObject(type, params, not_linked) {
    // return Vue.axios.post(url, q.stringify({
    //     'action' : type + '/get',
    //     ...filterParams(params)
    // }));
    let model = null
    if (!type.split("/")[1]) {
        model = type
        type = type + "/get";
    }
    else model = type.split("/")[0]
    if (!window.myStore.objects[model]) window.myStore.objects[model] = {}
    if (typeof params === 'string' || params instanceof String || !isNaN(params)) params = {id: params}
    return new Promise((resolve, reject) => {

        const key_o = params && params.id ? JSON.stringify(params) : null;
        _log_('getObject loading for:', key_o, window.myStore.objects)
        // if (key_o && window.myStore.objects[model][key_o]) {
        //     if (not_linked)
        //         resolve(JSON.parse(JSON.stringify(window.myStore.objects[model][key_o])));
        //     else resolve(window.myStore.objects[model][key_o])
        //     return
        // }
        Vue.axios
           .post(
               url,
               q.stringify({
                   action: type,
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {
                   if (key_o) window.myStore.objects[model][key_o] = null
                   reject({
                       message: r.data.message,
                   });
               }
               else {
                   if (r.data.results) {
                       if (r.data.results.length > 1)
                           console.error(
                               "Call for object returned more  than one results ",
                               type,
                               params
                           );
                       if (key_o) {

                           window.myStore.objects[model][key_o] = r.data.results[0]
                       }
                       resolve(r.data.results[0]);
                   }
                   else {
                       if (key_o) window.myStore.objects[model][key_o] = r.data.object
                       resolve(r.data.object);
                   }
               }
           })
           .catch((e) => {
               if (key_o) window.myStore.objects[model][key_o] = null
               reject(e);
           });
    });
}

export function fetchProcessor(processor, params) {
    // _log_("here.fetchProcessor...", processor, params);
    let trans_params = {};
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const element = params[key];
            if (_.isArray(element) && key.indexOf("[]") < 0)
                trans_params[key + "[]"] = element;
            else trans_params[key] = element;
        }
    }
    _log_("here..go..", url);
    return Vue.axios.post(
        url,
        q.stringify({
            action: processor,
            ...filterParams(trans_params),
        })
    );
}

export function ajax_download(action, data, json_package) {
    const purl = url + "?HTTP_MODAUTH=" + window.Travel.auth + "&ctx=web";
    if (!data.limit) data.limit = 0
    return Vue.axios.post(
                  purl,
                  q.stringify({
                      action: action,
                      ...filterParams(data),
                  }), {responseType: 'blob'}
              )
              .then((response) => {
                  // _log_('ajax_download....',response.headers['content-disposition'],response.headers['content-type'])
                  const fileNameParts = response.headers['content-disposition'].split('filename="'),
                      fnm = fileNameParts[1].replace('"', '')
                  const url = URL.createObjectURL(new Blob([response.data], {
                      type: response.headers['content-type']
                  }))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', fnm)
                  document.body.appendChild(link)
                  link.click()
                  link.remove();
              });

}

export function html_ajax_download(action, data, json_package) {
    const purl = url + "?HTTP_MODAUTH=" + window.Travel.auth + "&ctx=web";
    _log_("download..", purl, data, json_package);
    var $iframe, iframe_doc, iframe_html;

    if (($iframe = $("#download_iframe")).length !== 0)
        $("#download_iframe")
            .remove();
    $iframe = $(
        "<iframe id='download_iframe'" +
        " style='display: none' src='about:blank'></iframe>"
    )
        .appendTo("body");

    iframe_doc = $iframe[0].contentWindow || $iframe[0].contentDocument;
    if (iframe_doc.document) {
        iframe_doc = iframe_doc.document;
    }
    iframe_doc.write("");
    let data_to_sent = "";
    if (json_package)
        data_to_sent =
            "<input type=hidden name='" +
            json_package +
            "' value='" +
            JSON.stringify(data) +
            "'/>";
    else
        for (const key in data) {
            _log_("down,,," + key, data);
            if (data.hasOwnProperty(key)) {
                const element = data[key];
                if (_.isString(element) || _.isNumber(element) || _.isBoolean(element))
                    data_to_sent +=
                        "<input type=hidden name='" + key + "' value='" + element + "'/>";
                else if (_.isArray(element)) {
                    const arrkey = key.indexOf('[]') > 0 ? key : key + '[]';
                    element.forEach((ei) => {
                        if (ei)
                            data_to_sent +=
                                "<input type=hidden name='" + arrkey + "' value='" + ei + "'/>";
                    });
                }
            }
        }
    data_to_sent += "<input type=hidden name='action' value='" + action + "'/>";
    iframe_html =
        "<html><head></head><body><form method='POST' action='" +
        purl +
        "'>" +
        data_to_sent +
        "</form>" +
        "</body></html>";
    _log_("sent....", iframe_html);
    iframe_doc.open();
    iframe_doc.write(iframe_html);
    $(iframe_doc)
        .find("form")
        .submit();
}

export function updateProcessor(type, params) {
    let model = null
    if (!type.split("/")[1]) {
        model = type
        type = type + "/update";
    }
    else model = type.split("/")[0]
    const key_o = params && params.id ? params.id : null;
    _log_('params', params)
    return new Promise((resolve, reject) => {
        Vue.axios
           .post(
               url,
               q.stringify({
                   action: type,
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {
                   if (key_o && window.myStore.objects[model]) window.myStore.objects[model][key_o] = null
                   reject({
                       message: r.data.message,
                   });
               }
               else {
                   if (key_o && window.myStore.objects[model]) window.myStore.objects[model][key_o] = null
                   resolve(r.data.object);
               }
           })
           .catch((e) => {
               if (key_o && window.myStore.objects[model]) window.myStore.objects[model][key_o] = null
               reject(e);
           });
    });
}

export function updateJsonProcessor(type, paramsTojson) {
    const params = {data: JSON.stringify(paramsTojson)};
    return new Promise((resolve, reject) => {
        Vue.axios
           .post(
               url,
               q.stringify({
                   action: type,
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {
                   reject({
                       message: r.data.message,
                   });
               }
               else {
                   resolve(r.data.object);
               }
           })
           .catch((e) => {
               reject(e);
           });
    });
}

export function updateObject(type, params) {
    return new Promise((resolve, reject) => {
        Vue.axios
           .post(
               url,
               q.stringify({
                   action: type + "/update",
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {
                   reject({
                       message: r.data.message,
                   });
               }
               else {
                   resolve(r.data.object);
               }
           })
           .catch((e) => {
               reject(e);
           });
    });
}

export function removeObject(type, params) {
    return new Promise((resolve, reject) => {
        Vue.axios
           .post(
               url,
               q.stringify({
                   action: type + "/remove",
                   ...filterParams(params),
               })
           )
           .then((r) => {
               if (!r.data.success) {
                   reject({
                       message: r.data.message,
                   });
               }
               else {
                   resolve(r.data.object);
               }
           })
           .catch((e) => {
               reject(e);
           });
    });
}

function xfilterParams(params) {
    return _.omitBy(
        params,
        (param, key) =>
            // _.endsWith(key, "_format") ||
            // _.endsWith(key, "_tag") ||
            // _.endsWith(key, "_tags") ||
            // _.endsWith(key, "_title") ||
            key == "action"
    );
}

function filterParams(params, excludeNulls) {
    // _log_("go ahead//", params);
    params = _.omitBy(
        params,
        (param, key) =>
            // _.endsWith(key, "_format") ||
            // _.endsWith(key, "_tag") ||
            // _.endsWith(key, "_tags") ||
            // _.endsWith(key, "_title") ||
            key == "action"
    );
    var sentParams = {};
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            let element = params[key];
            if (element !== null && element !== undefined) {
                // _log_("go ahead/2/" + key, element);
                if (_.isArray(element) && !element.length) element = ''
                else if (_.isArray(element) && key.indexOf("[]") < 0) key = key + "[]";
                else if (_.isObject(element) && element.length === undefined) {
                    // _log_("go ahead/2OVBJDS/", element);
                    element = JSON.stringify(element);
                }
                sentParams[key] = element;
            }
            else if (!excludeNulls) sentParams[key] = element;
        }
    }
    // _log_("go ahead/2/", sentParams);
    return sentParams;
}

// export function fetchSingle(type){
//     return new Promise(function(resolve, reject) {
//         setTimeout(function() {
//           resolve(type);
//         }, 1000);
//       });
// }
